import React from "react";
import { useLang } from "@/contexts/LangContext";
import MotionReveal from "@/components/MotionReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const Faq = () => {
  const { t, dict } = useLang();
  return (
    <div data-testid="faq-page">
      <section className="mx-auto max-w-[900px] px-5 sm:px-8 pt-24 sm:pt-32">
        <MotionReveal>
          <p className="editorial-kicker">{t("faq.overline")}</p>
        </MotionReveal>
        <MotionReveal delay={0.05}>
          <h1 className="editorial-h1 mt-6 text-4xl sm:text-6xl lg:text-7xl max-w-[20ch]">{t("faq.title")}</h1>
        </MotionReveal>
      </section>

      <section className="mx-auto max-w-[900px] px-5 sm:px-8 mt-12 sm:mt-16 pb-24">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {dict.faq.items.map((it, i) => (
            <AccordionItem key={it.q} value={`item-${i}`} className="border-b border-border">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-serif-display text-2xl sm:text-3xl text-left py-6 hover:no-underline"
              >
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-foreground/75 leading-relaxed text-base max-w-[60ch]">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
};

export default Faq;
